
import { instantiate } from './prism-prism-demo-core.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


